import { DownArrowIcon } from '@/assets/DownArrowIcon';
import React from 'react';

interface DetileTextImageProps {
  imageSrc: string;
  fallbackImage?: string; // 読み込みエラー時用の代替画像（任意）
  defaultFallback?: string; // fallbackImage が未指定の場合の既定画像
  verticalText?: string | null; // 縦書きテキスト（あれば下記と同様の表示をする）
  bottomText?: string | React.ReactNode;
  imageTall?: boolean;
  bottomTextPosition?: 'center' | 'bottom-left';
}

export const DetileTextImage: React.FC<DetileTextImageProps> = ({
  imageSrc,
  fallbackImage,
  defaultFallback = '/images/no_image.png',
  verticalText = null,
  bottomText = null,
  imageTall = true,
  bottomTextPosition = 'center',
}) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = fallbackImage || defaultFallback;
  };

  return (
    <div className="relative w-full overflow-hidden">
      {/* スマホサイズ表示 */}
      <div className="block md:hidden overflow-x-auto">
        <img
          src={imageSrc}
          alt="Background"
          className="object-cover w-auto h-auto"
          onError={handleImageError}
        />
        {bottomText && <div className="py-2">{bottomText}</div>}
      </div>

      {/* PCサイズ表示: 高さ800pxに固定 */}
      <div className="hidden md:flex relative w-full h-[800px]">
        <div className="w-1/2">
          <img
            src={imageSrc}
            alt="Background"
            className="w-full h-full object-cover"
            onError={handleImageError}
          />
        </div>
        <div className="w-1/2 relative">
          {bottomText && (
            <div
              className={
                bottomTextPosition === 'center'
                  ? 'flex flex-col justify-center items-center w-full h-full'
                  : 'absolute bottom-0 left-0 pt-4 px-4 mt-8'
              }
            >
              {bottomText}
            </div>
          )}
          {verticalText && (
            <div className="absolute top-1/2 right-0 transform -translate-y-1/2 mr-3">
              <p
                className="text-black text-[18px]"
                style={{ writingMode: 'vertical-rl' }}
              >
                {verticalText}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetileTextImage;
